import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import banner from "modules/banner";
import dataFormatter from "utils/dataFormatter";
import "./Banner.css";

class Banner extends Component {
  constructor(props) {
    super(props);
    props.getBanner();
  }

  render() {
    const bannerId = this.props.bannerId;

    const note = dataFormatter(this.props.banner)[bannerId]
      ? dataFormatter(this.props.banner)[bannerId][0]
      : "";
    // const note = (dataFormatter(this.props.banner))[0] ? (dataFormatter(this.props.banner))[0][0] : ''
    return (
      <div>
        {note ? (
          <div className="row margin-large banner">
            <div className="width-2">
              <a href={note.url} className="banner-link">
                <img
                  className="image"
                  src={`${process.env.REACT_APP_IMG_SERVER}/img/${note.image_id}/large`}
                  alt=""
                />
                <p className="image-title">{note.title}</p>
              </a>
            </div>
            <div
              style={{ whiteSpace: "pre-line", fontSize: "13px" }}
              className="width-2"
            >
              {note.content}
              <a href={note.url} className="arrow">
                {" "}
              </a>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  banner: state.banner.data
});

const mapDispatchToProps = dispatch => ({
  getBanner: bindActionCreators(banner.actions.getBanner, dispatch)
});

Banner.propTypes = {
  id: PropTypes.number
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Banner);



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js